<section [formGroup]="stepForm">
  <div
    *ngIf="!isRestorePlan"
    [attr.data-e2e]="elementsSelector.name.notRestorePlanBlock">
    <div
      *ngIf="isVirtual"
      [attr.data-e2e]="elementsSelector.name.isVirtualBlock">
      <mbs-form-group>
        <mbs-destination-folder-input
          [buttonId]="'destination-step-virtual-destination-folder-tree'"
          [control]="destinationFolderControl"
          [destinationFolderParams]="destinationFolderParams"
          [disabledSelf]="destinationFolderControl.disabled"
          [hasTargetComputer]="!!mainService?.targetComputerData"
          [inputId]="'destination-step-virtual-destination-folder'"
          [isUnix]="isUnix"
          [name]="'destination-step-virtual-destinationFolder'"
          [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
      </mbs-form-group>

      <mbs-form-group>
        <mbs-input
          formControlName="virtualImageName"
          name="virtualImageName"
          [attr.data-e2e]="elementsSelector.name.virtualImageName"
          [id]="'virtual-image-name'"
          [label]="'wizards:destinationOld.dest_virtual_image_name_label' | i18next"
          [validationWhitespace]="true"></mbs-input>
      </mbs-form-group>

      <div class="form-row align-items-center mb-2">
        <div class="col-4">
          <label
            class="mbs-form_label mb-0"
            for="capacity-number">
            {{ 'wizards:destinationOld.dest_capacity' | i18next }}
          </label>
        </div>
        <div class="col-4">
          <mbs-number
            formControlName="capacity"
            [id]="'capacity-number'"
            [max]="numberIsFocused ? 65536.0 : maximumSizeNumber || 65536.0"
            [min]="numberIsFocused ? 0 : minimumSizeNumber || 0.02"
            (blur)="capacityBlurHandler()"
            (change)="capacityInputHandler($event)"
            (focus)="capacityFocusHandler()"></mbs-number>
        </div>
        <div class="col-auto">
          GB
          <span
            class="cursor-help fa fa-info-circle text-info ml-2"
            placement="right"
            [container]="'body'"
            [ngbTooltip]="'wizards:destinationOld.dest_capacity_label' | i18next"></span>
        </div>
      </div>
      <div class="form-row">
        <div class="col-6 offset-4">
          {{ 'wizards:destinationOld.dest_minimum_label' | i18next }} <span class="fw-semibold">{{ minimumSizeGB || 0.02 }} GB</span><br />
          {{ 'wizards:destinationOld.dest_maximum_label' | i18next }} <span class="fw-semibold">{{ maximumSizeGB || 65536.0 }} GB</span>
        </div>
      </div>
    </div>

    <mbs-form-group
      *ngIf="!isVirtual"
      [attr.data-e2e]="elementsSelector.name.isNotVirtualBlock">
      <mbs-radio
        formControlName="isPhysical"
        name="isPhysicalRadio"
        [descriptionOutside]="false"
        [id]="'is-physical-disk-radio-0'"
        [label]="'wizards:destinationOld.dest_physical_disk_label' | i18next"
        [value]="true"
        (change)="isPhysicalChangeHandler($event)">
        <ng-template radioDescription>
          <mbs-select
            formControlName="selectedDisk"
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [clearable]="false"
            [id]="'physical-disk-select'"
            [items]="diskItems"></mbs-select>
          <mbs-alert
            class="mb-0 mt-3"
            [icon]="true"
            [type]="mbsPopupType.info">
            {{ 'wizards:destinationOld.dest_physical_disk_label_alert' | i18next }}
          </mbs-alert>
        </ng-template>
      </mbs-radio>
      <mbs-radio
        formControlName="isPhysical"
        name="isPhysicalRadio"
        [descriptionOutside]="false"
        [id]="'is-physical-disk-radio-1'"
        [label]="'wizards:destinationOld.dest_specific_part_label' | i18next"
        [value]="false"
        (change)="isPhysicalChangeHandler($event)">
        <ng-template radioDescription>
          <mbs-table-grid
            class="mb-3"
            id="destination-step-table"
            listType="table"
            [data]="myPartitions"
            [disableViewSwitch]="true"
            [headers]="headers"
            [maxHeight]="'286px'"
            [selectable]="false"
            [showHeaders]="true"
            [switcherView]="false">
            <ng-template
              let-disk
              mbsTableCell>
              {{ disk.label }}
            </ng-template>
            <ng-template
              let-disk
              let-index="rowIndex"
              mbsTableCell>
              <mbs-form-group class="mb-0">
                <mbs-select
                  [appendTo]="'.modal-content'"
                  [bindLabel]="'label'"
                  [bindValue]="'value'"
                  [clearable]="false"
                  [dropdownPosition]="'auto'"
                  [formControl]="getPartitionControl(index)"
                  [id]="'specific-partition-select' + disk.id"
                  [items]="partitionsForSelectsData[disk.id]"
                  [searchable]="false"
                  [textOverflow]="false"
                  (change)="selectedSpecificPartitionsChangeHandler()">
                  <ng-template
                    #mbsSelectOptionTmp
                    let-part="item">
                    <div class="form-row">
                      <div class="col overflow-hidden">
                        <span
                          container="body"
                          placement="top-left"
                          [ngbTooltip]="part.isSelected ? tooltipData : part.label"
                          >{{ part.label }}</span
                        >
                        <ng-template #tooltipData>
                          <span class="d-block text-start">
                            {{ part.label }}<br />
                            {{ 'wizards:already_selected_tooltip' | i18next }}
                          </span>
                        </ng-template>
                      </div>
                      <div
                        *ngIf="part.isSelected"
                        class="col-auto">
                        <span class="ico ico-ok text-gray-500"></span>
                      </div>
                    </div>
                  </ng-template>
                </mbs-select>
              </mbs-form-group>
            </ng-template>
          </mbs-table-grid>
        </ng-template>
      </mbs-radio>
    </mbs-form-group>
  </div>

  <div
    *ngIf="isRestorePlan"
    [attr.data-e2e]="elementsSelector.name.restorePlanBlock">
    <mbs-form-group>
      <mbs-radio
        formControlName="toOriginalLocation"
        name="toOriginalLocation"
        [id]="'to-original-location-1'"
        [label]="'wizards:destinationOld.destOriginalLocationLabel' | i18next"
        [value]="true"
        (change)="toOriginalLocationChangeHandler($event)"></mbs-radio>
      <mbs-radio
        formControlName="toOriginalLocation"
        name="toOriginalLocation"
        [descriptionOutside]="false"
        [id]="'to-original-location-2'"
        [label]="'wizards:destinationOld.dest_specific_location_label' | i18next"
        [value]="false"
        (change)="toOriginalLocationChangeHandler($event)">
        <ng-template radioDescription>
          <mbs-form-group>
            <mbs-destination-folder-input
              [buttonId]="'destination-step-destination-folder-tree'"
              [control]="destinationFolderControl"
              [destinationFolderParams]="destinationFolderParams"
              [disabledSelf]="destinationFolderControl.disabled"
              [hasTargetComputer]="!!mainService?.targetComputerData"
              [inputId]="'destination-step-destination-folder'"
              [isUnix]="isUnix"
              [name]="'destination-step-destinationFolder'"
              [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
          </mbs-form-group>
          <mbs-checkbox
            *ngIf="
              (!isUnix || isNetBuild) &&
              stepForm.get('destinationFolder').enabled &&
              destinationAsDefault !== stepForm?.get('destinationFolder')?.value
            "
            formControlName="saveLocationAsDefault"
            [attr.data-e2e]="elementsSelector.name.saveLocationAsDefault"
            [id]="'save-location-as-default'"
            [label]="'wizards:destinationOld.dest_save_default_label' | i18next"></mbs-checkbox>
        </ng-template>
      </mbs-radio>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="!isUnix || isNetBuild || isNBF"
      [attr.data-e2e]="elementsSelector.name.notUnixOrNBFBlock">
      <mbs-checkbox
        formControlName="restoreDeletedFiles"
        [id]="'restore-deleted-files'"
        [label]="'wizards:destinationOld.dest_deleted_label' | i18next">
        <ng-container appendLabel>
          <span
            class="cursor-help fa fa-info-circle text-info ml-2"
            container="body"
            [ngbTooltip]="'wizards:destinationOld.dest_deleted_label_tooltip' | i18next"></span>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-checkbox
        formControlName="overwriteExistingFiles"
        [descriptionOutside]="false"
        [id]="'overwrite-existing-files'"
        [label]="'wizards:destinationOld.dest_overwrite_label' | i18next"
        (change)="overwriteChangeHandler($event)">
        <ng-template checkboxDescription>
          <mbs-checkbox
            formControlName="restoreOnlyNewFiles"
            [id]="'restore-only-new-files'"
            [label]="'wizards:destinationOld.dest_only_new_label' | i18next">
            <ng-container appendLabel>
              <span
                class="cursor-help fa fa-info-circle text-info ml-2"
                container="body"
                [ngbTooltip]="'wizards:destinationOld.dest_only_new_label_tooltip' | i18next"></span>
            </ng-container>
          </mbs-checkbox>
        </ng-template>
      </mbs-checkbox>
    </mbs-form-group>

    <mbs-form-group
      *ngIf="!isUnix || isNetBuild"
      [attr.data-e2e]="elementsSelector.name.notUnixBlock">
      <mbs-checkbox
        formControlName="restoreNTFSPermissions"
        [id]="'restore-ntfs-permissions'"
        [label]="'wizards:destinationOld.dest_ntfs_perm_label' | i18next">
        <ng-container appendLabel>
          <span
            class="cursor-help fa fa-info-circle text-info ml-2"
            container="body"
            [ngbTooltip]="'wizards:destinationOld.dest_ntfs_perm_label_tooltip' | i18next"></span>
        </ng-container>
      </mbs-checkbox>
    </mbs-form-group>
  </div>

  <mbs-alert
    *ngIf="stepForm.get('selectedSpecificPartitions')?.errors?.isAllRequired"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.isAllRequired"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:destinationOld.dest_all_partitions_select_alert' | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="stepForm.get('selectedSpecificPartitions')?.errors?.isNotUniq"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.isNotUniq"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:destinationOld.dest_must_be_unique_alert' | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="stepForm?.get('selectedDisk')?.errors?.isBoot || stepForm?.get('selectedSpecificPartitions')?.errors?.isBoot"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.isBoot"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:destinationOld.dest_must_be_not_boot_alert' | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="
      !isVirtual &&
      (stepForm.get('isPhysical')?.value
        ? stepForm.get('selectedDisk')?.errors?.diskSpace
        : stepForm.get('selectedSpecificPartitions')?.errors?.diskSpace)
    "
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.diskSpace"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:destinationOld.dest_space_disk_alert' | i18next }}
  </mbs-alert>

  <mbs-alert
    *ngIf="!isCurrentComputer && (!isUnix || isNetBuild)"
    class="mb-0 mt-3"
    [attr.data-e2e]="elementsSelector.name.notCurrentNotUnix"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:destinationOld.dest_remote_to_local_alert' | i18next }}
  </mbs-alert>
</section>
